import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FiLogIn, FiUserPlus } from "react-icons/fi";
import { useAuth } from "../../auth/AuthContext";

export default function AuthModal({ show, onHide, onSuccess }) {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login"); // "login" | "register"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const isLogin = mode === "login";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const fn = isLogin ? login : register;
      await fn(email.trim().toLowerCase(), password);
      setBusy(false);
      setPassword("");
      onSuccess && onSuccess();
      onHide && onHide();
    } catch (err) {
      setBusy(false);
      setError((err && err.message) || "Something went wrong. Please try again.");
    }
  };

  const swap = (next) => {
    setMode(next);
    setError("");
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="auth-dialog">
      <div className="auth-card">
        <div className="auth-head">
          <div className="auth-logo">A</div>
          <h3>{isLogin ? "Welcome back" : "Create your account"}</h3>
          <p>
            {isLogin
              ? "Sign in to sync your progress across devices."
              : "Sign up to back up your progress to the cloud."}
          </p>
        </div>

        <form onSubmit={submit} className="auth-form">
          {error ? <div className="auth-error">{error}</div> : null}

          <label htmlFor="auth-email">Email</label>
          <input
            id="auth-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            autoComplete="email"
            required
          />

          <label htmlFor="auth-password">Password</label>
          <input
            id="auth-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="At least 6 characters"
            autoComplete={isLogin ? "current-password" : "new-password"}
            minLength={6}
            required
          />

          <button type="submit" className="nb-btn nb-btn-primary auth-submit" disabled={busy}>
            {isLogin ? <FiLogIn size={16} /> : <FiUserPlus size={16} />}
            {busy ? "Please wait…" : isLogin ? "Sign in" : "Create account"}
          </button>
        </form>

        <div className="auth-switch">
          {isLogin ? (
            <span>
              New here?{" "}
              <button type="button" onClick={() => swap("register")}>
                Create an account
              </button>
            </span>
          ) : (
            <span>
              Already have an account?{" "}
              <button type="button" onClick={() => swap("login")}>
                Sign in
              </button>
            </span>
          )}
        </div>

        <p className="auth-note">
          Your progress is always saved on this device. Signing in just adds free cloud backup
          &amp; multi-device sync.
        </p>
      </div>
    </Modal>
  );
}
